<script setup lang="ts">
import ForecastTable from '@/components/forecast/ForecastTable.vue';
import { entraAuthService } from '@/services/auth/entra-auth-service';
import { models, pagePermissions, utils } from 'cesg-shared';
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';

const route = useRoute();
const { t } = useI18n();
const forecastDataChanged = ref(0);

const user = entraAuthService.me.value;

const projectId = utils.type.asType<string>(route.params.id);

const permissionTo = computed(() => pagePermissions(projectId, user)?.forecast);

const handleDataChanged = () => {
  forecastDataChanged.value++;
};

const showTableInputs = computed(() => ({
  invoiceLink: !!permissionTo.value?.read.invoiceLink,
  comments: !!permissionTo.value?.read.comments,
}));

const disabledTableInputs = computed(() => ({
  comments: !permissionTo.value?.edit.comments,
  accountTranslation: !permissionTo.value?.edit.accountTranslation,
  inputs: !permissionTo.value?.edit.forecast,
}));
</script>
<template>
  <div class="table-container">
    <h1 class="is-size-4">{{ t('forecast.titleForecast') }}</h1>
    <ForecastTable
      :forecast-type="models.ForecastType.Forecast"
      :dataChanged="forecastDataChanged"
      :show="showTableInputs"
      :should-disable="disabledTableInputs"
      @dataChanged="handleDataChanged"
    />
    <h1 class="is-size-4 mt-6">{{ t('forecast.titleForecastAtaLopande') }}</h1>
    <ForecastTable
      :forecast-type="models.ForecastType.AtaOngoing"
      :dataChanged="forecastDataChanged"
      :show="showTableInputs"
      :should-disable="disabledTableInputs"
      @dataChanged="handleDataChanged"
    />

    <h1 class="is-size-4 mt-6">{{ t('forecast.titleForecastAtaFast') }}</h1>
    <ForecastTable
      :forecast-type="models.ForecastType.AtaFixed"
      :dataChanged="forecastDataChanged"
      :show="showTableInputs"
      :should-disable="disabledTableInputs"
      @dataChanged="handleDataChanged"
    />
  </div>
</template>

<style scoped lang="scss">
// Bulma's `.table-container` sets `overflow-y: hidden`, which makes this a
// scroll container and prevents the tables' sticky headers from sticking to
// the top of the viewport. Let the page (window) be the scroller instead.
.table-container {
  overflow: visible;
}
</style>
